import { FC } from "react";
import PrepState75Svg from "../../public/icons/PrepState75.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const GeometryBuildUpPrepState75Icon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><PrepState75Svg/></span>;
